import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const WhatsappButton = () => {

  const phoneNumber = "919871238339"; // without +

  const message = `Hello Divine Technology 👋

I’m interested in your services:

Corporate IT Solutions & Refurbished Laptops

Please assist me.`;

  const handleClick = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  return (
    <div className="fixed bottom-20 right-4 z-50">

      <button
        onClick={handleClick}
        className="bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition transform hover:scale-110 animate-bounce"
      >
        <FaWhatsapp size={24} />
      </button>

    </div>
  );
};

export default WhatsappButton;